import Podcast from './Podcast';
import Collection from './Collection';
import { isEmpty } from 'util/index';
import { UniversalCollection, UniversalConfig, UniversalPodcast } from '../interfaces';
import { TILE_SIZES } from 'globalConst/const';

interface UniversalPodcastCollection extends UniversalCollection {
  items: UniversalPodcast[];
}

/**
 * @class
 * A representation of a PodcastCollection
 *
 * @param {object} collection - collection model
 */
export default class PodcastCollection extends Collection {
  tileSizes: string = TILE_SIZES.SMALL;
  items: Array<Podcast>;

  constructor(collection: UniversalCollection, config: UniversalConfig[], options: string[]) {
    super(collection, config, options);

    if (isEmpty(collection)) {
      return null;
    }

    const podcastCollection = <UniversalPodcastCollection>collection;

    this.tileSizes = TILE_SIZES.SMALL;
    this.items = podcastCollection.items && podcastCollection.items.map((podcast) => new Podcast(podcast));

    // Make this class read-only
    Object.freeze(this);
  }
}
